import type { KeyboardEvent } from 'react'

export const sortAlphabetically = (a, b) => {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

export const preventEnterSubmit = (event: KeyboardEvent<HTMLElement>) => {
  if (event.key !== 'Enter') {
    return
  }

  const target = event.target as HTMLElement
  const tagName = target.tagName.toLowerCase()

  if (tagName !== 'textarea') {
    event.preventDefault()
  }
}
